/**
 * Abrir a conta da pessoa de qualquer ponto da casca (menu lateral, barra superior,
 * folha do celular): "Ver perfil" leva a Configurações → Perfil e segurança e
 * "Preferências" a Configurações → Preferências (Configuracoes.dc.html). Quem navega
 * é a Casca, que está sempre montada; quem quer abrir chama `abrirPerfil(secao)`.
 */
const ouvintes = new Set();

export function abrirPerfil(secao = 'seguranca') {
  ouvintes.forEach((ouvir) => ouvir(secao));
}

export function ouvirAbrirPerfil(ouvir) {
  ouvintes.add(ouvir);
  return () => ouvintes.delete(ouvir);
}
